import { ReactElement, ReactNode } from 'react';
import {
  StyledLink,
  Wrapper,
} from './styles';
import { ChevronRight } from 'icons';

interface NewBreadcrumbProps {
  items: { text: string, link?: string }[];
}

export const NewBreadcrumb = ({
  items,
}: Readonly<NewBreadcrumbProps>): ReactElement | null => {
  if (!items?.length) return null;

  const parts: ReactNode[] = [];
  for (let index = 0; index < items.length; index++) {
    const linkPath = items[index].link;
    const itemText = items[index].text;
    const isLast = index === items.length - 1;

    if (linkPath) {
      parts.push(
        <StyledLink
          key={`lnk:${linkPath}`}
          to={linkPath}
          variant={isLast ? 'primary' : 'grey'}
        >
          <span>{itemText}</span>
          {!isLast && <ChevronRight />}
        </StyledLink>,
      );
    } else {
      parts.push(
        <StyledLink
          key={`lnk-text:${itemText}`}
          to=""
          variant="grey"
          disabled
        >
          <span>{itemText}</span>
          {!isLast && <ChevronRight />}
        </StyledLink>,
      );
    }
  }

  return (
    <Wrapper>
      {parts}
    </Wrapper>
  );
};
